<template>
  <li
    class="flex items-center space-x-3 cursor-pointer p-2 rounded-md"
    :class="{
      'bg-[#E0E5F8]': isHovered,
      'bg-blue-440': !isHovered && isActive,
      'border-l-2 border-teal-900 rounded-l-none text-teal-900': selected,
    }"
    :data-testid="`${dataTestId}-item`"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
    @click="emit('menu-item-clicked')"
  >
    <a v-if="href" :href="href" class="flex items-center space-x-3 w-full">
      <span v-if="muiIconName" class="material-symbols-outlined">{{muiIconName}}</span>
      <div
        v-else-if="$slots.icon"
        class="text-lg font-semibold"
        :data-testid="`${dataTestId}-icon`"
      >
        <slot name="icon" />
      </div>
      <span
        :class="['font-montserrat text-sm font-semibold', !selected ? 'text-university-primary' : 'text-teal-900' ]"
        :data-testid="`${dataTestId}-text`"
      >
        {{ text }}
      </span>
    </a>
    <router-link v-else :to="routerLink" class="flex items-center space-x-3 w-full">
      <span v-if="muiIconName" class="material-symbols-outlined">{{muiIconName}}</span>
      <div
        v-else-if="$slots.icon"
        class="text-lg font-semibold"
        :data-testid="`${dataTestId}-icon`"
      >
        <slot name="icon" />
      </div>
      <span
        :class="['font-montserrat text-sm font-semibold', !selected ? 'text-university-primary' : 'text-teal-900' ]"
        :data-testid="`${dataTestId}-text`"
      >
        {{ text }}
      </span>
    </router-link>
    <Badge v-if="count" class="ml-auto mr-4 !bg-blue-400 pr-2 !font-semibold !text-black" :class="{ '!bg-teal-900 !text-white': selected }" :value="count"></Badge>
  </li>
</template>

<script setup>
import Badge from "primevue/badge";
import { computed, onMounted, ref, toRefs } from "vue";
import { RouterLink, useRoute, useRouter } from "vue-router";

const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  routerLink: {
    type: Object,
    required: false,
  },
  href: {
    type: String,
    required: false,
  },
  dataTestId: {
    type: String,
    required: true,
  },
  muiIconName: {
    type: String,
    required: false,
  },
  count: {
    type: Number,
    required: false,
  },
  enableSelectedLinks: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const route = useRoute();
const router = useRouter();
const isReady = ref(false);
const isHovered = ref(false);

const emit = defineEmits(["menu-item-clicked"]);

const isActive = computed(() => {
  if (!isReady.value) {
    return false;
  }
  return props.routePath === (route.params.page ?? "");
});

const selected = computed(() => {
  return props.enableSelectedLinks && props.routerLink && route.name === props.routerLink.name;
});

onMounted(async () => {
  await router.isReady();
  isReady.value = true;
});
</script>
